import React, { Fragment } from "react";
import { faEnvelopeOpen, faPhone, faSms } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getChannelFlagColor } from "../../../utils/normalize";

import moment from "moment";

export const campaignOnOffTableSchema = (channelUpdateDialog) => [
  {
    dataField: "id",
    text: "TemplateId",
    hidden: true,
  },
  {
    dataField: "company_code",
    text: "Company Code",
    sort: true,
  },
  {
    dataField: "type",
    text: "Type",
    sort: true,
  },
  {
    dataField: "subtype",
    text: "Subtype",
    sort: true,
  },
  {
    dataField: "Channel",
    text: "Channel",
    isDummyField: true,
    headerStyle: () => ({ width: "100px" }),
    formatter: (cell, rowData) => (
      <div className="text-nowrap">
        <Fragment>
          <a
            href="#0"
            onClick={() => {
              channelUpdateDialog("sms", rowData);
            }}
          >
            <FontAwesomeIcon
              icon={faSms}
              size="lg"
              color={getChannelFlagColor(rowData.sms)}
              className="mr-3"
            />
          </a>
          &nbsp;
          <a
            href="#0"
            onClick={() => {
              channelUpdateDialog("email", rowData);
            }}
          >
            <FontAwesomeIcon
              icon={faEnvelopeOpen}
              size="lg"
              color={getChannelFlagColor(rowData.email)}
              className="mr-3"
            />
          </a>
          &nbsp;
          <a
            href="#0"
            onClick={() => {
              channelUpdateDialog("voice", rowData);
            }}
          >
            <FontAwesomeIcon
              icon={faPhone}
              size="lg"
              color={getChannelFlagColor(rowData.voice)}
              className="mr-3"
            />
          </a>
          &nbsp;
        </Fragment>
      </div>
    ),
  },
  {
    dataField: "updated_at",
    text: "Updated At",
    sort: false,
    formatter: (updated_at) => {
      return updated_at ? moment(updated_at).format("lll") : "";
    },
  },
  {
    dataField: "updated_by",
    text: "Updated By",
    isDummyField: true,
    sort: false,
    formatter: (cell, rowData) =>
      (rowData.firstname_vch || " ") + " " + (rowData.lastname_vch || " "),
  },
  {
    dataField: "user_id_bint",
    text: "Updated By Id",
    sort: true,
    hidden: true,
  },
];
